// removed by extract-text-webpack-plugin
module.exports = {"modalLoading":"qempo_VerificationModal_modalLoading-2dmtM_R","title":"qempo_VerificationModal_title-3deWhY0","content":"qempo_VerificationModal_content-3RnDDxk","buttonsWrap":"qempo_VerificationModal_buttonsWrap-1bTj1DQ","btn":"qempo_VerificationModal_btn-2RNWOgI"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/auth-modals/verification-modal/component/VerificationModal.scss
// module id = 1963
// module chunks = 0